import { FormattedMessage, useIntl } from 'react-intl';
import { Card } from 'ui-components/components/card';
import { Text, TextType } from 'ui-components/components/text';
import { NumberInput } from 'ui-components/components/number-input';
import { useEnableMobilePickingShowLocationStep } from '../../../../../feature-flags/hooks/use-enable-mobile-picking-show-location-step';
import { PickListCheckboxSetting } from '../printed-section/printed-section-settings/pick-list-checkbox-setting';
import { PickListDropdownSetting } from '../printed-section/printed-section-settings/pick-list-dropdown-setting';
import { PickSetting } from '../../components/pick-setting/pick-setting';
import { messages } from './messages';
import { MOBILE_CONFIGURATION_DROPDOWN_SETTINGS, MOBILE_CONFIGURATION_CHECKBOX_SETTINGS } from './constants';
import style from '../printed-section/style.module.less';

export const MobileConfigurationSection = ({ values, onSettingsChange }) => {
  const intl = useIntl();
  const isShowLocationStepEnabled = useEnableMobilePickingShowLocationStep();

  const updateSetting = (settingName, value) => {
    onSettingsChange?.(settingName, value);
  };

  const visibleCheckboxSettings = isShowLocationStepEnabled
    ? MOBILE_CONFIGURATION_CHECKBOX_SETTINGS
    : MOBILE_CONFIGURATION_CHECKBOX_SETTINGS.filter(({ settingKey }) => settingKey !== 'showLocationStep');

  return (
    <Card className={style['printed-section']}>
      <Text textType={TextType.H4} value={<FormattedMessage {...messages.mobileConfigurationTitle} />} />
      <PickSetting
        control={
          <NumberInput
            className={style['mobile-configuration-default-tote']}
            max={100}
            min={1}
            onChange={(value) => updateSetting('defaultToteQuantity', value)}
            value={values.defaultToteQuantity}
          />
        }
        descriptionMessage={messages.defaultQuantityDescription}
        titleMessage={messages.defaultQuantityOfTotes}
      />

      {visibleCheckboxSettings.map(({ settingKey, checkboxId, titleMessage, descriptionMessage, disabledWhen }) => (
        <PickListCheckboxSetting
          key={checkboxId}
          checkboxId={checkboxId}
          checked={values[settingKey]}
          descriptionMessage={descriptionMessage}
          disabled={disabledWhen?.(values) ?? false}
          onChange={(value) => updateSetting(settingKey, value)}
          titleMessage={titleMessage}
        />
      ))}

      {MOBILE_CONFIGURATION_DROPDOWN_SETTINGS.map(({ settingKey, titleMessage, items }) => (
        <PickListDropdownSetting
          key={settingKey}
          items={items.map((item) => ({
            key: item.key,
            name: intl.formatMessage(item.messageKey),
          }))}
          onChange={(value) => updateSetting(settingKey, value)}
          titleMessage={titleMessage}
          value={values[settingKey]}
        />
      ))}
    </Card>
  );
};
